import { render, staticRenderFns } from "./BrandPicker.vue?vue&type=template&id=4b91d9e8&scoped=true"
import script from "./BrandPicker.vue?vue&type=script&lang=js"
export * from "./BrandPicker.vue?vue&type=script&lang=js"
import style0 from "./BrandPicker.vue?vue&type=style&index=0&id=4b91d9e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91d9e8",
  null
  
)

export default component.exports